/*
  SMUD: precio dentro del botón "Añadir al carrito" ("Añadir al carrito – $99.976 $69.990").
  Si la ficha tiene Kaching, toma el precio del bundle elegido + los adicionales tildados.
  Si no tiene, usa el precio de la variante × la cantidad. Se actualiza solo al cambiar
  de bundle, de variante o de cantidad, y vuelve a ponerse si el theme redibuja el botón.
*/
class SmudAtcPrice extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;
    this.item = this.closest('.product-info__block-item') || this.parentElement;
    this.form = document.forms[this.getAttribute('form')];
    this.variantPrice = parseInt(this.dataset.price, 10) || 0;
    this.variantCompare = parseInt(this.dataset.compare, 10) || 0;
    this.showCompare = this.hasAttribute('show-compare');
    this.includeUpsells = this.hasAttribute('include-upsells');
    this.showPrice = !this.hasAttribute('no-price');
    this.showDispatch = this.hasAttribute('show-dispatch');
    this.dispatchText = this.showDispatch ? SmudAtcPrice.dispatchLabel() : '';
    this.preorderText = SmudAtcPrice.preorderLabel(this.getAttribute('preorder-date'));
    this.moneyFormat = this.dataset.moneyFormat || '${{amount_with_comma_separator}}';

    this.form?.addEventListener('variant:change', (e) => {
      const v = e.detail?.variant;
      if (!v) return;
      this.variantPrice = v.price || 0;
      this.variantCompare = v.compare_at_price || 0;
      this.schedule();
    });
    this.form?.addEventListener('change', () => this.schedule());
    this.item.addEventListener('input', () => this.schedule());

    // El theme redibuja el botón al cambiar de variante: se vuelve a poner el precio
    this.buttonObserver = new MutationObserver(() => this.schedule());
    this.buttonObserver.observe(this.item, { childList: true, subtree: true });

    window.addEventListener('resize', () => this.schedule(), { passive: true });
    this.watchKaching();
    this.schedule();
  }

  watchKaching() {
    const k = document.querySelector('kaching-bundles-block');
    if (k) {
      this.kaching = k;
      new MutationObserver(() => this.schedule()).observe(k, { attributes: true, childList: true, subtree: true });
      k.addEventListener('click', () => setTimeout(() => this.schedule(), 50));
      return;
    }
    // Kaching se monta después de la carga: se lo espera unos segundos
    if ((this._kTries = (this._kTries || 0) + 1) < 20) setTimeout(() => this.watchKaching(), 300);
  }

  schedule() {
    if (this._raf) return;
    this._raf = setTimeout(() => {
      this._raf = null;
      this.update();
    });
  }

  parseMoney(text) {
    let s = (text || '').replace(/[^\d.,]/g, '');
    if (!s) return 0;
    if (/,\d{1,2}$/.test(s)) s = s.replace(/\./g, '').replace(',', '.');
    else if (/\.\d{1,2}$/.test(s)) s = s.replace(/,/g, '');
    else s = s.replace(/[.,]/g, '');
    return Math.round(parseFloat(s) * 100) || 0;
  }

  formatMoney(cents) {
    const fmt = (n, dec, th, ds) => {
      const [i, d] = (n / 100).toFixed(dec).split('.');
      // Montos redondos sin decimales ("$69.990" en vez de "$69.990,00") para que entre en una línea
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d && d !== '00' ? ds + d : '');
    };
    return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }

  totals() {
    const bar = this.kaching?.querySelector('.kaching-bundles__bar--selected');
    if (bar) {
      const priceText = bar.querySelector('.kaching-bundles__bar-price')?.textContent || '';
      let price = this.parseMoney(priceText);
      let compare = this.parseMoney(bar.querySelector('.kaching-bundles__bar-full-price')?.textContent) || price;
      // "Llevá 2 · $59.491,50 c/u": Kaching muestra el precio POR UNIDAD; el botón muestra el total
      if (/c\s*\/\s*u/i.test(priceText)) {
        const qIn = this.item.querySelector('input[name="quantity"]') || this.form?.querySelector('input[name="quantity"]') || document.querySelector(`input[name="quantity"][form="${this.form?.id}"]`);
        const q = Math.max(1, parseInt(qIn?.value, 10) || 1);
        price *= q;
        compare *= q;
      }
      // Por defecto se muestra el precio del bundle tal cual lo muestra Kaching.
      // Con el ajuste prendido se suman los adicionales tildados (ej. el Ice Roller opcional).
      if (this.includeUpsells) bar.querySelectorAll('.kaching-bundles__upsell').forEach((up) => {
        if (!up.querySelector('.kaching-bundles__upsell__checkbox--selected')) return;
        const p = this.parseMoney(up.querySelector('.kaching-bundles__upsell__price')?.textContent);
        price += p;
        compare += this.parseMoney(up.querySelector('.kaching-bundles__upsell__full-price')?.textContent) || p;
      });
      return { price, compare };
    }
    const qtyInput = this.item.querySelector('input[name="quantity"]') || this.form?.querySelector('input[name="quantity"]');
    const qty = Math.max(1, parseInt(qtyInput?.value, 10) || 1);
    return { price: this.variantPrice * qty, compare: (this.variantCompare || 0) * qty };
  }

  // "Se despacha …": mismo cálculo que el bloque "Se despacha hoy/mañana" (corte 12 hs de Argentina,
  // salta fines de semana y feriados). Si se cambian los feriados, cambiarlos también en ese bloque.
  static dispatchLabel() {
    const HOLIDAYS = [
      '2025-01-01','2025-03-03','2025-03-04','2025-03-24','2025-04-02',
      '2025-04-17','2025-04-18','2025-05-01','2025-05-25','2025-06-16',
      '2025-07-09','2025-08-17','2025-10-13','2025-11-24','2025-12-08','2025-12-25',
      '2026-01-01','2026-02-16','2026-02-17','2026-03-23','2026-04-02',
      '2026-04-03','2026-05-01','2026-05-25','2026-06-15','2026-07-09',
      '2026-08-17','2026-10-12','2026-11-23','2026-12-08','2026-12-25',
      '2027-01-01','2027-02-08','2027-02-09','2027-03-24','2027-03-26',
      '2027-04-02','2027-05-01','2027-05-25','2027-06-21','2027-07-09',
      '2027-08-16','2027-10-11','2027-11-20','2027-12-08','2027-12-25'
    ];
    const DAYS = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
    const pad = (n) => String(n).padStart(2, '0');
    const key = (d) => d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    const isBusinessDay = (d) => d.getDay() !== 0 && d.getDay() !== 6 && HOLIDAYS.indexOf(key(d)) === -1;
    const nextBD = (d) => { const c = new Date(d.getTime()); c.setDate(c.getDate() + 1); while (!isBusinessDay(c)) c.setDate(c.getDate() + 1); return c; };
    const n = new Date();
    const now = new Date(n.getTime() + n.getTimezoneOffset() * 60000 - 3 * 3600000);
    const dispatch = (isBusinessDay(now) && now.getHours() < 12) ? now : nextBD(now);
    const tomorrow = new Date(now.getTime()); tomorrow.setDate(tomorrow.getDate() + 1);
    const dm = pad(dispatch.getDate()) + '/' + pad(dispatch.getMonth() + 1);
    if (key(dispatch) === key(now)) return 'hoy ' + dm;
    if (key(dispatch) === key(tomorrow)) return 'mañana ' + dm;
    return 'el ' + DAYS[dispatch.getDay()] + ' ' + dm;
  }

  // Preventa (metadato custom.preventa_fecha, aaaa-mm-dd): "15/11" si la fecha es hoy o más adelante
  // (hora de Argentina). Si ya pasó, la preventa terminó y vuelve "Se despacha …".
  static preorderLabel(iso) {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
    if (!m) return '';
    const n = new Date();
    const ar = new Date(n.getTime() + n.getTimezoneOffset() * 60000 - 3 * 3600000);
    const pad = (x) => String(x).padStart(2, '0');
    const today = ar.getFullYear() + '-' + pad(ar.getMonth() + 1) + '-' + pad(ar.getDate());
    if (`${m[1]}-${m[2]}-${m[3]}` < today) return '';
    return `${m[3]}/${m[2]}`;
  }

  // Segunda línea debajo del texto del botón ("Se despacha mañana 21/10" o, con preventa, "Envío desde el 15/11")
  placeDispatch(button, label, on) {
    let ds = label.querySelector('.smud-atc-dispatch');
    button.classList.toggle('smud-atc--two-lines', on);
    if (!on) { ds?.remove(); return; }
    if (!ds) {
      ds = document.createElement('span');
      ds.className = 'smud-atc-dispatch';
    }
    const html = this.preorderText
      ? `Envío desde el <strong>${this.preorderText}</strong>`
      : `Se despacha <strong>${this.dispatchText}</strong>`;
    if (ds.innerHTML !== html) ds.innerHTML = html;
    if (label.lastElementChild !== ds) label.appendChild(ds);
  }

  update() {
    const button = this.item.querySelector('buy-buttons button[type="submit"]');
    if (!button) return;
    const label = button.querySelector(':scope > div') || button;
    let tag = label.querySelector('.smud-atc-price');
    const { price, compare } = this.totals();
    const off = button.disabled || button.getAttribute('aria-disabled') === 'true';

    this.placeDispatch(button, label, this.showDispatch && !off);
    if (off || !price || !this.showPrice) {
      tag?.remove();
      return;
    }
    const html = ` <span class="smud-atc-price__sep">·</span>`
      + (this.showCompare && compare > price ? ` <s class="smud-atc-price__compare">${this.formatMoney(compare)}</s>` : '')
      + ` <span class="smud-atc-price__amount">${this.formatMoney(price)}</span>`;
    if (tag && tag.innerHTML === html) return this.fit(button, label, tag);
    if (!tag) {
      tag = document.createElement('span');
      tag.className = 'smud-atc-price';
      const ds = label.querySelector('.smud-atc-dispatch');
      ds ? label.insertBefore(tag, ds) : label.appendChild(tag);
    }
    tag.innerHTML = html;
    if (!this._marked) { this._marked = true; try { performance.mark('smud-atc-price:precio'); } catch (e) {} }
    this.fit(button, label, tag);
  }

  // Si el texto no entra en una línea (celular), primero se achica el precio y si
  // todavía no entra se saca el precio tachado
  fit(button, label, tag) {
    tag.classList.remove('is-tight', 'is-no-compare');
    label.style.whiteSpace = 'nowrap';
    const cs = getComputedStyle(button);
    // Se mide contra el ancho del contenedor: con el texto en una línea el botón no puede crecer
    const boxW = Math.min(button.clientWidth, button.parentElement.clientWidth);
    const avail = boxW - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    const overflows = () => label.scrollWidth > avail + 1;
    if (overflows()) tag.classList.add('is-tight');
    if (overflows()) tag.classList.add('is-no-compare');
    if (overflows()) label.style.whiteSpace = '';
  }
}

if (!customElements.get('smud-atc-price')) customElements.define('smud-atc-price', SmudAtcPrice);
